//#region import libraries
import React, { useEffect, useState } from 'react';

// tremor
import { Flex } from '@tremor/react';

// bootstrap
import { Card as BootstrapCard, Button } from 'react-bootstrap';

// redux
import { useSelector } from "react-redux";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// styling
import { Spacing } from '_styles';

// custom components
import { CustomSubtitle, CustomMetric, CollapsibleComponent } from '_atoms';
import { PassengerListMiniTable } from '_organisms';

// icons
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const itemsPerPage = 6;

//#endregion


// card used to display location information in airport locations page
const NormalLocationCard = (props) => {

    //#region redux
    const usedTheme = useSelector(selectUsedTheme);

    const [tableData, setTableData] = useState([]); // data to be displayed in passenger table
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [passengerCount, setPassengerCount] = useState(0);

    const [locationTitle, setLocationTitle] = useState('Location Title');

    //#endregion

    const [collapsed, setCollapsed] = useState(false);
    const [locationColor, setLocationColor] = useState(false);
    //#region useEffect

    useEffect(() => {
        if (props.location) {

            //console.log('props.location', props.location)

            if (props.location.locationName) {
                setLocationTitle(props.location.locationName);
            }

            if (props.location.paxArray && props.location.paxArray.length > 0) {
                let paxArray = [...props.location.paxArray]
                paxArray = sortByDepartureTime(paxArray)
                const totalPax = paxArray.length;
                setPassengerCount(totalPax);
                setTotalPages(Math.ceil(totalPax / itemsPerPage));

                const startIndex = (currentPage - 1) * itemsPerPage;
                const paginatedData = paxArray.slice(startIndex, startIndex + itemsPerPage);
                setTableData(paginatedData);
            } else {
                setPassengerCount(0);
                setTableData([]);
            }

            if (props.location.color) {
                setLocationColor(props.location.color);
            }
        }
    }, [props.location, currentPage]);


    //#endregion

    //#region Pagination Handlers
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    //#endregion

    //#region Helper Functions

    // sorting paxArray due to depart soonest
    const sortByDepartureTime = (array) => {
        return array.sort((a, b) => {
            // convert departure times to Date objects for comparison
            const timeA = new Date(a?.flightConfirmationDetails?.departureTime || a?.flightInformation?.flightTime);
            const timeB = new Date(b?.flightConfirmationDetails?.departureTime || b?.flightInformation?.flightTime);
            // compare the times
            return timeA - timeB;
        });
    };
    //#endregion

    return (
        <div style={{ minHeight: '100px', height: '100%', maxWidth: '100%' }}>
            <BootstrapCard style={{ height: '100%', width: '100%', backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }} >

                {/* title */}
                <div style={{ padding: Spacing.SCALE_8 }}>
                    <Flex>

                        {/* location name */}
                        <CustomSubtitle setToolTip={[true, 'Location Title']}>{locationTitle}</CustomSubtitle>

                        {/* location color */}
                        <div style={{ padding: Spacing.SCALE_4 }}>
                            {locationColor && <div style={{ width: 10, height: 10, backgroundColor: locationColor, borderRadius: 50 }} />}
                        </div>

                    </Flex>

                    {/* passenger count */}
                    <div style={{ display: 'flex', marginTop: -Spacing.SCALE_8 }}>
                        <CustomMetric>{passengerCount}</CustomMetric>
                        <p style={{ marginTop: 32, marginLeft: 4 }} data-tippy-content="Passengers at Location">Passenger{passengerCount !== 1 ? 's' : ''}</p>
                    </div>
                </div>

                {/* table */}
                <div style={{ marginTop: -Spacing.SCALE_50 }}>
                    <CollapsibleComponent collapsable={passengerCount > 0} setCollapsed={(val) => { setCollapsed(val) }}>
                        <PassengerListMiniTable
                            headers={['Pax', 'Assis', 'Des', 'Act', 'Updated']}
                            passengers={tableData}
                            totalNumber={passengerCount}
                        />
                    </CollapsibleComponent>
                </div>

                {/* pagination */}
                <div style={{ marginTop: Spacing.SCALE_8 }}>
                    {tableData && tableData.length > 0 && collapsed ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: -12 }}>
                            {/* Previous Button */}
                            <button
                                onClick={handlePreviousPage}
                                disabled={currentPage === 1}
                                style={{
                                    border: 'none',
                                    background: 'none',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                    padding: '5px',
                                    opacity: currentPage === 1 ? 0.5 : 1
                                }}
                            >
                                <FiChevronLeft size={20} />
                            </button>

                            {/* Page Indicator */}
                            <p style={{ margin: '0 0px', fontSize: '12px' }}>
                                Page {currentPage} of {totalPages}
                            </p>

                            {/* Next Button */}
                            <button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                                style={{
                                    border: 'none',
                                    background: 'none',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                    padding: '5px',
                                    opacity: currentPage === totalPages ? 0.5 : 1
                                }}
                            >
                                <FiChevronRight size={20} />
                            </button>
                        </div>

                        : null}
                </div>


            </BootstrapCard>
        </div>
    );
};

export default NormalLocationCard;